<template>
  <div class="parking_info_block" :class="{ 'b-color' : selected.featured_product !== '1' && selected.product_id !== featured }">
    <span class="title-block" v-if="selected.featured_product == '1' || selected.product_id == featured">
      {{ $t('airportparking.results.product.recommended') }}
    </span>
    <div class="parking_info_holder">
      <div class="left_align">
        <div class="wrap_detail">
          <h2>
            <a nohref @click="moreInfo = selected">{{ shortenName(selected.product_name, airport.airport_name) }}</a>
          </h2>
          <ul class="locatin-info">
            <li v-if="selected.transfer_time > 0">
              <span class="ico icon-bus"></span>
              <span class="text">
                {{ parseInt(selected.transfer_time) || 0 }} 
                {{ $t('airportparking.results.product.transfer') }}
              </span>
            </li>
            <li v-if="selected.distance_from_airport > 0">
              <span class="ico icon-location"></span>
              <span class="text">
                {{ selected.distance_from_airport || 0 }} {{ selected.distance_from_airport == 1 ? distanceUnit.replace('s', '') : distanceUnit }}
                <span class="d-none d-md-inline">{{ $t('airportparking.results.product.from') }} </span>
                <span class="d-md-none">{{ $t('airportparking.results.product.to') }}</span>
                <span class="d-none d-md-inline">{{ $t('airportparking.results.product.the') }} </span> 
                {{ $t('general.airport') }}
              </span>
            </li>
            <li v-if="(selected.transfer_time == 0 && selected.distance_from_airport == 0) || selected.product_name.includes('Storey')">
              <span class="ico icon-walk"></span>
              <span class="text">
                {{ $t('airportparking.results.product.walk') }}
              </span>
            </li>
          </ul>
          <div class="info-holder">
            <div class="imgs-holder mr-4">
              <div class="img-box width">
                <a nohref @click="moreInfo = selected">
                  <img 
                    :src="`https://s3-eu-west-1.amazonaws.com/skyassets/resources/carpark_logos/${selected.product_id}_241_121.png`" :alt="selected.product_name" 
                    @error="$event.target.src = fallbackImage"
                  />
                </a>
              </div>
              <div class="img-box" v-if="selected.reevoo_short">
                <reevoo 
                  :average="selected.reevoo_short.average_score" 
                  :count="selected.reevoo_short.review_count" 
                  :product-id="parseInt(selected.product_id)" 
                  :review-id="selected.reviews_product_id"
                />
              </div>
            </div>
            <div class="text-holder">
              <ul class="list">
                <li v-for="(item, key) in selected.short_info" :key="key">
                  {{ item }}
                </li>
              </ul>
              <div class="award-holder" v-if="selected.park_mark_award === '1'">
                <div class="icon-award">
                  <img :src="`${cdn}/images/image60.png`" :alt="$t('airportparking.results.product.park_mark')" />
                </div>
                <span class="text-award">{{ $t('airportparking.results.product.park_mark') }}</span>
              </div>
              <span class="more-view" @click="moreInfo = selected">{{ $t('airportparking.results.product.more_info') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right_align">
        <div class="align-holder">
          <h3>{{ $t('airportparking.results.product.options') }}</h3>
          <div class="booking_holder" v-if="products.length > 1">
            <form @submit.prevent>
              <ul class="booking-options">
                <li v-for="(upgrade, key) in products" :key="key">
                  <label class="radio-label" :for="`radio-${selected.product_id}-${key}`">
                    <input 
                      type="radio" 
                      :checked="upgrade.product_id === selected.product_id" 
                      @click="switchProduct(upgrade)" 
                      name="radio" 
                      :id="`radio-${selected.product_id}-${key}`"
                    />
                    <span class="fake-input"></span>
                    <span class="fake-label">{{ upgrade.park_name_short }}</span>
                    <span v-if="upgrade.product_id === selected.product_id" class="icon-check_circle"></span>
                    <span v-if="upgrade.product_id !== selected.product_id" class="booking-price">
                      {{ upgrade.price >= selected.price ? '+' : '-' }}
                      {{ currency }}{{ Math.abs((upgrade.price - selected.price)).toFixed(2) }}
                    </span>
                  </label>
                </li>
              </ul>
            </form>
          </div>
          <a v-if="!saved" nohref class="btn-save" @click="save = selected">{{ $t('airportparking.results.product.save') }}</a>
          <p v-else>{{ $t('airportparking.results.product.saved') }}</p>

          <div class="results-addon-promo" v-if="promotionAddons(selected)">
            <div class="addon-promotion">
              <div class="addon-promotion__extras">
                {{ $t('payment.addon.extras') }}
              </div>
              <div class="addon-promotion__addons">
                <div class="addon-promotion__item" v-for="addon in promotionAddons(selected)" :key="addon.addon_id" v-tooltip="{ 
                  content: `
                    <strong>${addon.addon_name}</strong>
                    <p>${ addon.addon_desc }</p>
                  `}">
                  <span class="addon-promotion__check"></span>
                  {{ addon.addon_name_short }}
                </div>
              </div>
            </div>
          </div>

          <a v-if="selected.promo_hidden === '1'" class="btn-reveal" @click="reveal = true;" nohref>{{ $t('airportparking.results.product.reveal_promo') }}</a>
        </div>
        <div class="align-holder">
          <div class="lounge-info">
            <div class="price-detail">
              <h3 v-if="days > 0">
                {{ $t('airportparking.results.product.price_for') }}
                {{ days }} 
                {{ $t('airportparking.results.product.days_parking') }}
              </h3>
              <div class="wrap transition-wrap" v-if="parseFloat(selected.discount) > 0">
                <transition name="fade" @enter="enter">
                  <strong class="price" v-if="show">{{ currency }}{{ parseFloat(selected.price).toFixed(2) }}</strong>
                </transition>
                <transition name="fade" @enter="enter">
                  <span class="old-price" v-if="show">{{ currency }}{{ parseFloat(selected.full_price).toFixed(2) }}</span>
                </transition>
              </div>
              <div class="wrap" v-else>
                <transition name="fade" @enter="enter">
                  <strong class="price"  v-if="show">{{ currency }}{{ parseFloat(selected.price).toFixed(2) }}</strong>
                </transition>
              </div>
            </div>
            <div class="time-info">
              <span nohref class="save-btn mt-2" :class="{ 'results-save-btn' : selected.cashback_included === '1' }" v-if="parseFloat(selected.discount) > 0">
                <span v-if="selected.discount_percent > 0">{{ parseFloat(selected.discount_percent) }}% {{ $t('airportparking.results.product.cheaper_discount') }} {{ currency }}{{ selected.discount }}</span>
                <span v-else>{{ $t('airportparking.results.product.cheaper_discount_saving') }} {{ currency }}{{ selected.discount }}</span>
              </span>
              <span nohref class="save-btn cashback-save-btn mt-2" v-if="parseFloat(selected.discount) == 0 && selected.cashback_included === '1'">
                &#10003; {{ $t('airportparking.results.product.cashback') }} {{ currency }}{{ parseFloat(selected.cashback_amount).toFixed(2) }}
              </span>
              <span v-tooltip="{ content: `<p>${$t('airportparking.results.product.no_cashback_explainer')}.</p>`}" nohref class="save-btn cashback-save-btn no-cashback-save-btn mt-2" v-else-if="parseFloat(selected.discount) > 0 && selected.cashback_included === '1'">
                &#10007; {{ $t('airportparking.results.product.no_cashback') }} 
                <i class="icon-help"></i>
              </span>
              <ul class="time-list list-unstyled">
                <li>
                  <i class="icon-time"></i>
                  {{ $t('airportparking.results.product.last') }} {{ selected.last_booked }}
                </li>
                <li v-if="parseInt(selected.viewed_24h) > 0 ">
                  <i class="icon-eye"></i>
                  {{ selected.viewed_24h }} {{ $t('airportparking.results.product.viewing') }}
                </li>
              </ul>
            </div>
            <button type="button" @click="bookNow" class="btn btn-primary text-uppercase"> 
              {{ $t('airportparking.results.product.book_now') }}
            </button>
            <p v-if="selected.result_info" class="parking-fees text-danger" v-html="selected.result_info"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from 'vuex-pathify';
import * as _ from "lodash";
import { eventBus } from "@/eventBus";
import { Reevoo } from '@/components';
import mixins from '@/mixins';

export default {
  name: "item",
  components: { Reevoo },
  mixins: [mixins.validate, mixins.globals, mixins.format],
  watch: {
    product(value) {
      this.selected = value
    }
  },
  props: {
    products: { type: Array, default: () => [], required: false },
    product: { type: Object, default: () => {}, required: true },
    airport: { type: Object },
    featured: { default: "0" }
  },
  data() {
    return {
      selected: null,
      emailError: false,
      show: true,
      saved: false
    }
  },
  computed: {
    moreInfo: sync("modals/moreInfo"),
    days: get("quote/parking_days"),
    reveal: sync("modals/reveal"),
    save: sync("modals/save"),
    resultsAddons: get("results/products@addon"),
  },
  created() {
    this.selected = this.product;
    if(this.featured > "0") this.selected.featured_product = "0";

    eventBus.$on('SAVED', id => {
      if(id === this.selected.park_id) return this.saved = true;
    })
  },
  methods: {
    switchProduct(product) {
      this.fadeMe()
      this.selected = product
    },
    promotionAddons(selected) {
      let excluded = selected.exclude_addon_id || 0;
      return _.cloneDeep(this.resultsAddons).filter(a => {
        return a.free === "1" && a.addon_id !== excluded && (a.addon_type === "standard")
      })
    },
    bookNow() {
      eventBus.$emit("SELECTED", this.selected ? this.selected : this.product);
    },
    fadeMe() {
      this.show = !this.show
      this.enter()
    },
    enter() {
      setTimeout( () => {
        this.show = true;
      }, 600);
    }
  }
};
</script>